import './form.less';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router';

import InputField from '../../shared/form-elements/input';
import SelectField from '../../shared/form-elements/select/field';
import CheckboxField from '../../shared/form-elements/checkbox';

const Form = ({
	handleSubmit,
	pristine,
	submitting,
	advSystemSelectOptions,
	submitForm,
	editId,
	loadAffiliatesLookup,
	intl
}) => (
	<div className="form-container campaign-domains-form">
		<div className="form-container__head">
			<h2>{ intl(!editId ? 'Create new parking domain' : 'Edit parking domain') }</h2>
		</div>
		<div className="form-container__body">
			<form className="ui-form create-parking-domain" onSubmit={handleSubmit(data => submitForm(data, editId))}>

				<div className="ui-form__element">
					<Field name="domain" placeholder={ intl('Domain') } component={InputField} />
				</div>

				<div className="ui-form__element">
					<Field
						searchable={false}
						multi={false}
						name="adv_system"
						placeholder={ intl('Advertising system') }
						component={SelectField}
						options={advSystemSelectOptions}
					/>
				</div>

				<div className="ui-form__element">
					<Field
						searchable={true}
						multi={true}
						name="affiliate_ids"
						placeholder={ intl('Affiliate') }
						component={SelectField}
						options={loadAffiliatesLookup}
					/>
				</div>

				<div className="ui-form__element">
					<Field
						name="has_own_https"
						placeholder={ intl('Has own HTTPS') }
						component={CheckboxField} />
				</div>

				<div className="ui-form__element">
					<button className="ui-btn ui-btn-primary">{ intl(!editId ? 'Save' : 'Edit') }</button>
					<Link to="campaign-domains/">
						<button type="button" className="ui-btn ui-btn-cancel">
							{intl('Cancel')}
						</button>
					</Link>
				</div>
			</form>
		</div>
	</div>
);

Form.propTypes = {
	handleSubmit: PropTypes.func,
	pristine: PropTypes.bool,
	advSystemSelectOptions: PropTypes.array,
	submitting: PropTypes.bool,
	submitForm: PropTypes.func,
	editId: PropTypes.any,
	loadAffiliatesLookup: PropTypes.func,
	intl: PropTypes.func
};

export default reduxForm({
	form: 'campaignDomain-Form'
})(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/campaign-domains/components/form.js